module.exports = __webpack_public_path__ + "img/powered-by-norven.50857950.svg";